export const TYPE_FILTER_PARAM = 'typeFilter';
export const TYPE_FILTER = {
    fromCU05501: 'fromCU055-01',
    fromCU05504: 'fromCU055-04',
    fromCU05505ByName: 'fromCU055-05-by-name',
    fromCU05505: 'fromCU055-05',
};

export const BUY_NOW_PRICE_MAX = 'buyNowPriceMax';
export const BUY_NOW_PRICE_MIN = 'buyNowPriceMin';
export const OLD_MAX = 'oldMax';
export const OLD_MIN = 'oldMin';
export const AREA_ID = 'areaId';
export const AREA_CODE = 'areaCode';
export const LIST_AREA_ID = 'listAreaId';
export const STATION_ID = 'stationId';
